<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">職涯輔導</span>
        <div role="tablist">
            <b-button class="mb-1" block v-b-toggle.accordion-1>基本資料</b-button>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                            <div is="option" value="u">上</div>
                            <div is="option" value="d">下</div>
                        </form-select>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.EmpNo" id="EmpNo" label="工號" type="text" emp required></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.Name" id="Name" label="名稱" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-select v-model="vm.Property" id="Property" label="活動性質" required>
                            <slot name="property"></slot>
                        </form-select>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-date-input v-model="vm.Start" id="Start" label="日期(起)" required></form-date-input>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-date-input v-model="vm.End" id="End" label="日期(訖)" required></form-date-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.Place" id="Place" label="地點" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-textarea v-model="vm.Remark" id="Remark" label="備註" type="text"></form-textarea>
                    </div>
                </div>
            </b-collapse>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'careerCounselingDetail',
        api: '/api/careercounseling/',
        data: {},
    });
</script>

<style>
</style>